// domain/usecase/shift/UpdateShiftTimesUseCase.kt
package com.evoapps.evoshift.domain.usecase.shift

import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.domain.repository.ShiftRepository
import com.evoapps.evoshift.domain.model.AuditMetadata
import com.evoapps.evoshift.domain.util.AppClock.now // Twój import czasu

class UpdateShiftTimesUseCase(
    private val shiftRepository: ShiftRepository
) {
    suspend operator fun invoke(
        shiftId: String,
        newStart: String, // ISO
        newEnd: String,   // ISO
        editorUserId: String
    ): Result<Unit> {
        return try {
            val shift = shiftRepository.getShift(shiftId).getOrThrow()

            // Optymalizacja: Nie zapisuj, jeśli nic się nie zmieniło
            if (shift.plannedTime.start == newStart && shift.plannedTime.end == newEnd) {
                return Result.success(Unit)
            }

            val updatedShift = shift.copy(
                plannedTime = TimeRange(newStart, newEnd),
                version = shift.version + 1,
                // Jeśli grafik opublikowany -> oznaczamy jako "brudny" (zmiana nieopublikowana)
                hasUnpublishedChanges = shift.isPublished,
                metadata = shift.metadata.copy(
                    updatedAt = now().toString(),
                    updatedBy = editorUserId
                )
            )

            shiftRepository.updateShift(updatedShift).getOrThrow()
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}